(() => {
  const dialog = document.querySelector('[data-drop-popup]');
  const excludedPath = /\/(?:account|checkout|checkouts|challenge)(?:\/|$)/.test(window.location.pathname);
  if (!dialog || dialog.dataset.popupInitialized || dialog.dataset.designMode === 'true' || excludedPath || typeof dialog.showModal !== 'function') return;
  dialog.dataset.popupInitialized = 'true';
  const form = dialog.querySelector('form');
  const seenKey = 'paper-trail:drop-popup:seen';
  const pendingKey = 'paper-trail:drop-signup:pending';
  const delay = 20000;
  let shown = false;
  let timer;
  let returnFocus;
  const storage = {
    get(key) { try { return window.sessionStorage.getItem(key); } catch { return null; } },
    set(key, value) { try { window.sessionStorage.setItem(key, value); } catch {} },
    remove(key) { try { window.sessionStorage.removeItem(key); } catch {} }
  };
  const alreadySeen = () => shown || storage.get(seenKey) === '1';
  const remember = () => {
    shown = true;
    storage.set(seenKey, '1');
    window.clearTimeout(timer);
    timer = undefined;
  };
  const focusTarget = (explicit, result) => {
    const target = result || (explicit ? dialog.querySelector('input[type="email"]') : null) || dialog.querySelector('[data-drop-popup-close]');
    target?.focus({ preventScroll: true });
  };
  const openSignup = (trigger, explicit = false, result = null) => {
    if (dialog.open) {
      if (explicit) focusTarget(true, result);
      return;
    }
    returnFocus = trigger instanceof HTMLElement && trigger !== document.body ? trigger : document.getElementById('main');
    try {
      dialog.showModal();
      remember();
      focusTarget(explicit, result);
    } catch {}
  };
  dialog.querySelectorAll('[data-drop-popup-close]').forEach(button => {
    button.addEventListener('click', () => dialog.close());
  });
  dialog.addEventListener('close', () => {
    if (returnFocus?.isConnected && typeof returnFocus.focus === 'function') returnFocus.focus({ preventScroll: true });
  });
  form?.addEventListener('submit', event => {
    if (event.defaultPrevented) return;
    remember();
    storage.set(pendingKey, String(Date.now()));
  });
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const trigger = event.target.closest?.('[data-drop-signup], [data-drop-signup-open], a[href]');
    if (!trigger || dialog.contains(trigger)) return;
    if (!trigger.hasAttribute('data-drop-signup') && !trigger.hasAttribute('data-drop-signup-open')) {
      if (trigger.target && trigger.target !== '_self') return;
      const url = new URL(trigger.href, window.location.href);
      if (url.origin !== window.location.origin || !['#newsletter', '#DropPopup', '#DropNewsletter'].includes(url.hash)) return;
    }
    event.preventDefault();
    event.stopPropagation();
    const menu = trigger.closest('.site-menu');
    const focusReturn = menu?.querySelector('summary') || trigger;
    if (menu) menu.open = false;
    openSignup(focusReturn, true);
  }, true);
  document.addEventListener('focusin', event => {
    if (event.target.closest?.('#newsletter')) remember();
  });
  const openHash = () => {
    if (!['#newsletter', '#DropPopup', '#DropNewsletter'].includes(window.location.hash)) return false;
    openSignup(document.activeElement, true, dialog.querySelector('[data-drop-form-result]'));
    return true;
  };
  window.addEventListener('hashchange', openHash);
  const result = dialog.querySelector('[data-drop-form-result]');
  const pendingAt = Number(storage.get(pendingKey));
  const recentSubmission = pendingAt > 0 && Date.now() - pendingAt < 15 * 60 * 1000;
  if (pendingAt && !recentSubmission) storage.remove(pendingKey);
  if (result && (recentSubmission || window.location.hash === '#DropNewsletter')) {
    storage.remove(pendingKey);
    openSignup(document.getElementById('main'), true, result);
  } else if (!openHash() && document.querySelector('#newsletter .form-success')) remember();
  const attempt = () => {
    if (alreadySeen()) return;
    const active = document.activeElement;
    if (document.hidden || document.querySelector('dialog[open]') || active?.matches('input, textarea, select, [contenteditable="true"]')) {
      timer = window.setTimeout(attempt, 2000);
      return;
    }
    openSignup(active);
  };
  if (!alreadySeen()) timer = window.setTimeout(attempt, delay);
  window.addEventListener('pagehide', () => {
    window.clearTimeout(timer);
    timer = undefined;
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted || alreadySeen()) return;
    window.clearTimeout(timer);
    timer = window.setTimeout(attempt, delay);
  });
})();
